import axios from 'axios';
import { getAuthToken, setSession } from './storage/session';
import { navigate } from 'gatsby';

export default function AxiosConfig() {
  axios.defaults.baseURL = process.env.GATSBY_API_URL;

  axios.interceptors.response.use(
    (res) => res,
    (e) => {
      if (e?.response?.status === 401 && !e?.request?.responseURL?.includes('login')) navigate('/');
      return Promise.reject(e);
    }
  );

  setSession(getAuthToken() || '');
}
